import React, { Fragment } from 'react'
import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";
import LabUserHome from './LabUserHome';
import { Breadcrumbs } from '../../AbstractElements';
import { useTranslation } from 'react-i18next';

export default function LabUserList() {
    const { t } = useTranslation();
    return (
        <Fragment>            
            <Breadcrumbs mainTitle={t("List Of Lab Users")} parent={t("Home")} title={t("List Of Lab Users")} />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                       <LabUserHome/>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
